import React from 'react';
import FinalStepForm from './FinalStepForm';
import useIdentificationCode from '../hooks/useIdentificationCode';
import Loading from '../../../../../Components/Loading';

interface Props {
	patientId: string;
	workplaceId: string;
	onHealthPlanCreate: () => void;
}

const FinalStepFormWrapper: React.FC<Props> = ({
	patientId,
	workplaceId,
	onHealthPlanCreate,
}) => {
	const { nextIdentificationCode, updateLastIdentificationCode } =
		useIdentificationCode();

	const onHpCreate = async () => {
		await updateLastIdentificationCode();
		onHealthPlanCreate();
	};

	if (!nextIdentificationCode) {
		return <Loading />;
	}

	return (
		<FinalStepForm
			patientId={patientId}
			workplaceId={workplaceId}
			onHealthPlanCreate={onHpCreate}
			nextIdentificationCode={nextIdentificationCode}
		/>
	);
};

export default FinalStepFormWrapper;
